import { render } from "./TranslateProductsContentModal.vue?vue&type=template&id=21ca2d0d"
import script from "./TranslateProductsContentModal.vue?vue&type=script&lang=js"
export * from "./TranslateProductsContentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__